import React from 'react'
import { styled } from '@mui/system'
import { colors } from '../consts'
import { Img } from '../Image/Img'

type IconButtonParams = {
  sTheme?: 'light' | 'dark'
  size?: 'lg' | 'sm'
  border?: boolean
}

const IconCon = styled('div')<IconButtonParams>(
  ({ border, size, sTheme, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(1, 2),
    cursor: 'pointer',
    border: border ? `1px solid ${colors.lightestGrey}` : 'none',
    borderRadius: 12,
    padding: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0.5, 1),
    },
    '& .icon': {
      width: size === 'lg' ? 30 : 20,
      color: sTheme === 'dark' ? colors.white : colors.text,
      marginBottom: 7,
      [theme.breakpoints.down('sm')]: {
        marginBottom: 5,
      },
    },
    '& .label': {
      color: sTheme === 'dark' ? colors.white : colors.text,
      margin: theme.spacing(0.25, 1.5),
      fontSize: '0.8rem',
      fontWeight: 600,
      maxWidth: 100,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.6rem',
        margin: theme.spacing(0.25, 1),
      },
    },
  })
)

type IconButtonProps = {
  theme?: 'light' | 'dark'
  icUrl: string
  size?: 'lg' | 'sm'
  label?: string
  border?: boolean
}

export const IconButton: React.FC<React.PropsWithChildren<IconButtonProps>> = ({
  theme = 'light',
  icUrl,
  label,
  size = 'sm',
  border = false,
}) => {
  return (
    <IconCon size={size} sTheme={theme} border={border}>
      <Img className="icon" src={icUrl} alt={`${label || ''} icon`} />
      {label && <p className="label">{label}</p>}
    </IconCon>
  )
}
